const InvoiceDirection = {
    IN: 1,
    OUT: 2
};

export default InvoiceDirection;